import { URLS } from "@app/shared";
import { PageHeader } from "@design-system/components";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { toolLocales } from "../utils";

export function EmailSubscriptionCenterPage() {
  const locale = getCurrentLocaleCode();
  const { standard } = toolLocales(locale);

  return (
    <>
      <PageHeader
        translationKey="emailSubscriptionCenter"
        breadcrumbItems={[
          { label: trans("home"), link: URLS.home },
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("emailSubscriptionCenter") },
        ]}
      />
      <div className="container min-h-[calc(100vh-200px)] space-y-12 px-4 py-8">
        <euroland-tool
          data-tool-name="SubscriptionCentre2"
          data-tool-language={standard}
        />
      </div>
    </>
  );
}
